/* eslint-disable @typescript-eslint/naming-convention */
export interface User {
	userid: string;
	first_name: string;
	last_name: string;
	user_role: string;
	email_address: string;
}
